
import Vue from 'vue';
import { colors } from '../Token/token';
import SelectBox from '../SelectBox/SelectBox.vue';
import WebText from '../Text/Text.vue';
import EyeIcon from '../../Icons/Eye.vue';
import EyeSlashIcon from '../../Icons/EyeSlash.vue';
/**
 * > *This component is deprecated, please go to V2 > Input*
 *
 * Input component.
 *
 * This input is not including `Label`.
 */
export default Vue.extend<any, any, any, any>({
  name: 'TextInput',
  components: {
    SelectBox,
    WebText,
    EyeIcon,
    EyeSlashIcon
  },
  inheritAttrs: false,
  props: {
    /**
     * Variation of the input <br />
     * Possible value: `formal` | `base` | `currency` | `security`
     */
    variant: {
      type: String,
      default: 'base'
    },
    /**
     * Model of the Input.
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Arrow color of the SelectBox.
     */
    arrowFill: {
      type: String,
      default: '#bababa'
    },
    /**
     * List of options of SelectBox.
     * Possible value: `value: string; label: string `
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Left icon in the Input.<br />
     * @type {VueComponent}
     */
    leftIcon: {
      default: null
    },
    /**
     * Icon search in the right of the Input.<br />
     * @type {VueComponent}
     */
    searchIcon: {
      default: null
    },
    /**
     * Callback function when user click search.
     */
    search: {
      type: Function,
      default: () => {}
    },
    /**
     * Error state of the input.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Make input has border.
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * Make font weight SelectBox and additional field bold.
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Make placeholder of the left input.
     */
    additionField: {
      type: Boolean,
      default: false
    },
    /**
     * Make Input type formal with padding.<br />
     * `true` will be no padding.
     */
    formalPadding: {
      type: Boolean,
      default: false
    },
    /**
     * Text in left of the placeholder Input.
     */
    additionFieldValue: {
      type: String,
      default: ''
    },
    /**
     * Make left of the input has SelectBox<br />
     * If `additionSelectBox` is given, then SelectBox appears.
     */
    additionSelectBox: {
      type: Boolean,
      default: false
    },
    /**
     * Make input text blue
     */
    textBlue: {
      type: Boolean,
      default: false
    },
    /**
     * Font variant of the SelectBox and additional field.
     */
    fontVariant: {
      type: String,
      default: ''
    },
    /**
     * Ink of the Input and SelectBox.
     */
    ink: {
      type: String,
      default: 'highlight'
    },
    /**
     * Image source of left placeholder of Input.
     */
    imageField: {
      type: String,
      default: ''
    },
    /**
     * Type data of the input.<br />
     * Possible value: `default` | `security_numeric` | `currency` |<br />
     * `number` | `tel` | `string_id`
     */
    typeData: {
      type: String,
      default: 'default'
    },
    /**
     * Callback when user click on left placeholder Input.
     */
    onAdditionClick: {
      type: Function,
      default: () => {}
    },
    /**
     * Length of the security / PIN input.<br />
     * The props will be work if variant is `security`.
     */
    securityLength: {
      type: Number,
      default: 6
    },
    /**
     * Show the toggle (eye icon) in security / PIN input.<br />
     * The props will be work if variant is `security`.
     */
    securityMask: {
      type: Boolean,
      default: false
    },
    /**
     * Validation input for required field.
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Make input to paste-able value.
     */
    pasteInput: {
      type: Boolean,
      default: true
    },
    /**
     * Regex String for validation.<br />
     * If regex has backslash, please use `\\`
     */
    regexInput: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isSecurityActive: true,
      iconFill: '',
      focus: false,
      selectedValues: {}
    };
  },
  created() {
    this.iconFill = colors.uiGray;
    this.selectedValues = { value: '', selectedItem: '1' };
    if (this.required) {
      /**
       * Handle error state for input
       * @event inputState
       * @type {function}
       */
      this.$emit('inputState', this.value && this.value.length > 0);
    }
  },
  methods: {
    handleChange(e: Event) {
      const valueData = (e.target as HTMLInputElement).value;
      this.selectedValues.value = valueData;
      if (this.variant === 'currency' && valueData) {
        const numbers = /[0-9]/;
        if (!numbers.test(valueData)) {
          /**
           * Handle when the input value change.
           * @event input
           * @type {function}
           */
          this.$emit('input', '');
        } else {
          const stripText = parseInt(valueData.replace(/[^0-9]/g, ''), 10);
          const formatNumber = new Intl.NumberFormat('id-ID');
          this.$emit('input', this.additionSelectBox ? this.selectedValues : formatNumber.format(stripText));
          this.selectedValues.value = formatNumber.format(stripText);
          (e.target as HTMLInputElement).value = formatNumber.format(stripText);
        }
      } else if (this.variant === 'security' && this.typeData.toLowerCase() === 'security_numeric') {
        const stripText = valueData.replace(/[^0-9]/g, '');
        (e.target as HTMLInputElement).value = stripText;
        this.$emit('input', this.additionSelectBox ? this.selectedValues : stripText);
      } else {
        this.$emit('input', this.additionSelectBox ? this.selectedValues : valueData);
      }
      this.$emit('change', e);
    },
    handleKeyPress(evt: Event) {
      const dataValue = (evt.target as HTMLInputElement).value;
      const typeData = this.typeData.toLowerCase();
      const theEvent = evt || window.event;
      if (this.variant === 'currency' || typeData === 'number' || typeData === 'tel') {
        let key;
        // Handle paste
        if (theEvent.type === 'paste') {
          // @ts-ignore

          key = event.clipboardData.getData('text/plain');
        } else {
          // Handle key press
          // @ts-ignore
          key = theEvent.keyCode || theEvent.which;
          key = String.fromCharCode(key);
        }
        let regex = /[0-9]/;
        if (!regex.test(key) || (key === '0' && dataValue === '0')) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
        if (typeData === 'tel' && key !== '8' && (dataValue.length < 0 || dataValue.length > 13)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      } else if (typeData === 'string_id') {
        // @ts-ignore
        const key = theEvent.keyCode || theEvent.which;
        const keyData = String.fromCharCode(key);
        if ((keyData === '0' && dataValue.length === 0) || dataValue.length > 16) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      } else if (typeData === 'security_numeric') {
        // @ts-ignore
        const key = theEvent.keyCode || theEvent.which;
        const keyData = String.fromCharCode(key);
        let numericRegex = /[0-9]/;

        if (!numericRegex.test(keyData) || dataValue.length >= this.securityLength) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      } else if (this.regexInput !== null) {
        const customRegex = new RegExp(this.regexInput);
        // @ts-ignore
        const key = theEvent.keyCode || theEvent.which;
        const keyData = String.fromCharCode(key);

        if (!customRegex.test(keyData)) {
          theEvent.returnValue = false;
          if (theEvent.preventDefault) theEvent.preventDefault();
        }
      }
      this.$emit('keypress', evt);
    },

    handleButtonPressed() {
      if (typeof this.onAdditionClick === 'function') {
        this.onAdditionClick();
      }
    },

    handleChangeSelection(e: Event) {
      this.$emit('input', this.selectedValues);
    },
    handleSearch(e: Event) {
      if (typeof this.search === 'function') {
        this.search();
      }
    },
    handleFocus(e: Event) {
      this.focus = true;
      /**
       * Handle when Input state in `focus`
       * @event focus
       * @type {function}
       */
      this.$emit('focus', e);
    },
    handleBlur(e: Event) {
      this.focus = false;
      /**
       * Handle when Input state in `blur`
       * @event blur
       * @type {function}
       */
      this.$emit('blur', e);
      if (this.required) {
        this.$emit('inputState', this.value && this.value.length > 0 ? true : false);
      }
    },
    handlePaste(e: Event) {
      if (!this.pasteInput || this.typeData.toLowerCase() === 'security_numeric') {
        e.preventDefault();
        return;
      }
    },
    handleSecurityMaskClick() {
      this.isSecurityActive = !this.isSecurityActive;
    },

    focusToInput() {
      (this.$refs.baseInput as HTMLInputElement).focus();
    }
  },
  computed: {
    computedAdditionField() {
      return typeof this.onAdditionClick !== 'undefined' ? 'cursor:pointer' : '';
    },
    inputVal() {
      let value = this.value;
      if (this.additionSelectBox) {
        value = this.selectedValues.value;
      }
      if (this.variant === 'currency' && value) {
        const stringValue = String(value);
        const formatNumber = new Intl.NumberFormat('id-ID');
        const stripText = parseInt(stringValue.replace(/[^0-9]/g, ''), 10);
        value = formatNumber.format(stripText);
      }
      return value;
    },
    inputClasses() {
      return {
        additionPadding: this.additionField,
        bluetext: this.ink === 'label',
        'security-active': this.isSecurityDiscShown
      };
    },
    securityDiscString() {
      let result = '';
      const valueLength = this.value.length;
      for (let index = 0; index < valueLength; index++) {
        result += '\u2022';
      }
      return result;
    },
    isSecurityDiscShown(): boolean {
      return this.variant === 'security' && this.isSecurityActive && this.typeData === 'security_numeric';
    },
    inputTypeSecurity() {
      return this.variant === 'security' && this.typeData !== 'security_numeric' && this.isSecurityActive
        ? 'password'
        : this.$attrs.type || 'text';
    }
  }
});
